import { gql } from '@apollo/client'

export const EDIT_ORDER_SCHEDULE = gql`
  mutation EditOrderSchedule($input: EditOrderScheduleInput!) {
    editOrderSchedule(input: $input) {
      ... on EditOrderScheduleSuccess {
        towingOrder {
          id
        }
      }
      ... on ResourceNotFoundError {
        error {
          code
          message
        }
      }
      ... on UnauthorizedError {
        error {
          code
          message
        }
      }
      ... on InvalidParameterError {
        error {
          code
          message
        }
      }
    }
  }
`
